'use client';
import * as e from 'react';

function _define_property(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = i, e;
}
class ProgressiveImageBase extends e.Component {
    componentDidMount() {
        let { src: e, srcSetData: t } = this.props;
        this.loadImage(e, t);
    }
    componentDidUpdate(e) {
        let { src: t, placeholder: i, srcSetData: s } = this.props;
        t !== e.src && this.initializeState(t, i, s);
    }
    componentWillUnmount() {
        this.image && (this.image.onload = null, this.image.onerror = null);
    }
    initializeState(e, t, i) {
        this.setState({
            image: t,
            loading: !0
        }, ()=>{
            this.loadImage(e, i);
        });
    }
    render() {
        let { image: e, loading: t, srcSetData: i } = this.state, { children: s } = this.props;
        if (!s || 'function' != typeof s) throw Error("ProgressiveImage requires a function as its only child");
        return s(e, t, i);
    }
    constructor(e){
        super(e), _define_property(this, "image", void 0), _define_property(this, "loadImage", (e, t)=>{
            this.image && (this.image.onload = null, this.image.onerror = null);
            let i = new Image();
            this.image = i, i.onload = this.onLoad, i.onerror = this.onError, i.src = e, t && (i.srcset = t.srcSet, i.sizes = t.sizes);
        }), _define_property(this, "onLoad", ()=>{
            this.props.delay ? this.setImageWithDelay() : this.setImage();
        }), _define_property(this, "setImageWithDelay", ()=>{
            setTimeout(()=>{
                this.setImage();
            }, this.props.delay);
        }), _define_property(this, "setImage", ()=>{
            var e, t, i;
            this.setState({
                image: (null === (e = this.image) || void 0 === e ? void 0 : e.src) || '',
                loading: !1,
                srcSetData: {
                    srcSet: (null === (t = this.image) || void 0 === t ? void 0 : t.srcset) || '',
                    sizes: (null === (i = this.image) || void 0 === i ? void 0 : i.sizes) || ''
                }
            });
        }), _define_property(this, "onError", (e)=>{
            let { onError: t } = this.props;
            t && t(e);
        }), this.image = void 0, this.state = {
            image: e.placeholder,
            loading: !0,
            srcSetData: {
                srcSet: '',
                sizes: ''
            }
        };
    }
}

export { ProgressiveImageBase };
